<template>
  <div>
    <PageHeader :items="items" :optionalItems="optionalItems">
      <template #filters>
        <div class="search-filters">
          <SearchFilter :isFilterSearch="false">
            <li>
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("invoiceType") }}
                </label>
                <multiselect
                  v-model="form.invoiceType"
                  :options="['invoice-correction', 'invoice', 'invoice-storno']"
                  :multiple="false"
                >
                </multiselect>
              </div>
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("status") }}
                </label>
                <multiselect
                  v-model="form.status"
                  :options="[
                    'draft',
                    'approved',
                    'sent',
                    'warning level 1',
                    'warning level 2',
                    'warning level 3',
                    'paid',
                  ]"
                  :multiple="false"
                >
                </multiselect>
              </div>
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("customer") }}
                </label>
                <MultiSelectInput
                  v-model="form.company"
                  :options="customers"
                  :query="{ isMultiSelect: true }"
                  label="companyName"
                  trackBy="id"
                  moduleName="customers"
                  :multiple="false"
                  ><template #option="{ props }">
                    <div>
                      <p>
                        {{ props.option.companyNumber }} -
                        {{ props.option.companyName }}
                      </p>
                    </div>
                  </template>
                </MultiSelectInput>
              </div>
            </li>
          </SearchFilter>
          <div class="page-header-search">
            <input
              autocomplete="off"
              type="text"
              name="search"
              :placeholder="$t('search')"
              v-model="form.search"
            />
            <button class="" type="button" @click="reset">
              {{ $t("reset") }}
            </button>
          </div>
        </div>
      </template>
      <template #buttons>
        <!-- <button
          v-if="$can(`backoffice.invoice.export-invoice-summary`)"
          @click="openInvoiceSummaryModal()"
          class="btn btn-primary"
        >
          <span>{{ $t("invoiceSummary") }}</span>
        </button> -->
        <button
          v-if="$can(`${$route.meta.permission}.export-invoice-plan`)"
          @click="downloadInvoicePlan()"
          class="btn btn-primary"
        >
          <span>{{ $t("exportInvoicePlan") }}</span>
        </button>
        <button
          v-if="$can(`${$route.meta.permission}.export-csv`)"
          @click="downloadCSV()"
          class="btn btn-primary"
        >
          <span>{{ $t("exportCsv") }}</span>
        </button>
        <!-- <button
          v-if="$can(`${$route.meta.permission}.export-csv-latest`)"
          @click="downloadLatestCSV()"
          class="btn btn-primary"
        >
          <span>{{ $t("exportLatestCsv") }}</span>
        </button> -->
      </template>
    </PageHeader>
    <div class="custom-search d-flex justify-content-between mb-1">
      <div class="d-flex align-items-center">
        <div class="checkbox-group mr-2">
          <input
            type="checkbox"
            v-model="selectAll"
            @change="toggleSelectAll"
            class="checkbox-input"
            id="check"
          />
          <label for="check" class="checkbox-label">{{
            $t("selectAll")
          }}</label>
        </div>
        <!-- <button  class="btn btn-primary mr-1">
          <span>{{ $t("sendAllSelected") }}</span>
        </button> -->
        <button @click="generateSelected()" class="btn btn-primary">
          <span>{{ $t("generateSelected") }}</span>
        </button>
      </div>
    </div>
    <!--==================================-->
    <!--==================================-->
    <div class="dextop-table-view">
      <!-- table -->
      <div class="table-responsive api-keys-table">
        <vue-good-table
          styleClass="vgt-table striped"
          :columns="columns"
          :fixed-header="false"
          :rows="rows"
          :pagination-options="{
            enabled: false,
            perPage: pageLength,
          }"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-per-page-change="onPerPageChange"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->

            <span
              class="d-flex align-items-center justify-content-center gap-2"
              v-if="props.column.field === 'action'"
            >
              <div
                v-if="props.row.status == 'approved'"
                @click="toggleModal(props.row)"
                class="cursor-pointer"
                :title="$t('sendMail')"
              >
                <feather-icon size="16" icon="MailIcon" />
              </div>
              <div
                v-if="props.row.status == 'sent'"
                @click="showSentModal(props.row)"
                class="cursor-pointer"
                :title="$t('sendMail')"
              >
                <feather-icon size="16" icon="MailIcon" />
              </div>
              <div
                @click="generate(props.row)"
                class="cursor-pointer"
                :title="$t('generateDocument')"
              >
                <feather-icon size="16" icon="FileTextIcon" />
              </div>
              <div
                class="cursor-pointer"
                :title="$t('show')"
                @click="$router.push(`/invoices/${props.row.id}/show`)"
                v-if="
                  $can(`${$route.meta.permission}.list`) ||
                  $can(`${$route.meta.permission}.show-all`)
                "
              >
                <feather-icon size="16" icon="EyeIcon" />
              </div>
              <div
                v-if="$can(`${$route.meta.permission}.edit`)"
                class="cursor-pointer"
                :title="$t('edit')"
                @click="$router.push(`/invoices/${props.row.id}/edit`)"
              >
                <feather-icon size="16" icon="Edit2Icon" />
              </div>
              <div
                v-if="
                  props.row.status == 'draft' &&
                  $can(`${$route.meta.permission}.delete`)
                "
                class="cursor-pointer"
                :title="$t('trash')"
                @click="destroy(props.row.id)"
              >
                <feather-icon size="16" icon="TrashIcon" />
              </div>
            </span>

            <span v-else-if="props.column.field === 'totalAmount_numeric'">
              {{
                $formatter(
                  props.row.totalAmount,
                  $i18n.locale,
                  "EUR",
                  false,
                  2,
                  2
                )
              }}
            </span>
            <span v-else-if="props.column.field === 'dueDate'">
              <p class="">
                {{ $dateFormatter(props.row.dueDate, $i18n.locale) }}
              </p>
            </span>

            <span v-else-if="props.column.field === 'status'">
              <select
                class="form-control"
                :key="props.row"
                @change="updateInvoice(props.row, $event.target.value)"
                :disabled="!$can(`${$route.meta.permission}.edit`)"
              >
                <option
                  v-for="status in filterStatusOptions(props.row.status)"
                  :key="status"
                  :value="status"
                >
                  {{ status }}
                </option>
              </select>
            </span>
            <span
              v-else-if="props.column.field === 'netto_numeric'"
              style="white-space: nowrap"
            >
              {{
                $formatter(props.row.netto, $i18n.locale, "EUR", false, 2, 2)
              }}
            </span>

            <span v-else-if="props.column.field === 'taxAmount_numeric'">
              {{
                $formatter(
                  props.row.taxAmount,
                  $i18n.locale,
                  "EUR",
                  false,
                  2,
                  2
                )
              }}
            </span>
            <span v-else-if="props.column.field === 'Company.companyName'">
              {{ props.row.companyName }}
            </span>
            <span v-else-if="props.column.field === 'checkbox'">
              <div class="checkbox-group">
                <input
                  :id="'row-' + props.row.id"
                  v-model="selectedRows"
                  :value="props.row.id"
                  type="checkbox"
                  class="checkbox-input"
                />
                <label
                  :for="'row-' + props.row.id"
                  class="checkbox-label m-0"
                ></label>
              </div>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-5">
        <b-form-group class="m-0">
          <div class="d-flex align-items-center">
            <span class="text-nowrap"> {{ $t("rowsPerPage") }} </span>
            <b-form-select
              v-model="pageLength"
              :options="['25', '50', '100']"
              class="ml-1"
              @input="(value) => onPerPageChange({ pageLength: value })"
            />
          </div>
        </b-form-group>
        <div>
          <b-pagination
            :value="1"
            :total-rows="totalRecords"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="(value) => onPageChange({ currentPage: value })"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </div>
    <!--==================================-->
    <!--==================================-->
    <div class="reponsive-view-cards">
      <b-row>
        <b-col cols="12" lg="4" md="6" v-for="row in rows" :key="row.id">
          <div class="card">
            <div
              class="card-header d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div class="checkbox-group">
                  <input
                    :id="'row-' + row.id"
                    v-model="selectedRows"
                    :value="row.id"
                    type="checkbox"
                    class="checkbox-input"
                  />
                  <label
                    :for="'row-' + row.id"
                    class="checkbox-label m-0"
                  ></label>
                </div>
                <h5>{{ row.invoiceNumber }}</h5>
              </div>
              <div class="d-flex gap-3">
                <!-- Send Mail -->
                <div
                  v-if="row.status == 'approved'"
                  @click="toggleModal(row)"
                  class="cursor-pointer"
                  :title="$t('sendMail')"
                >
                  <feather-icon size="18" icon="MailIcon" />
                </div>

                <div
                  v-if="row.status == 'sent'"
                  @click="showSentModal(row)"
                  class="cursor-pointer"
                  :title="$t('mailSent')"
                >
                  <feather-icon size="18" icon="MailIcon" />
                </div>

                <!-- Generate Document -->
                <div
                  @click="generate(row)"
                  class="cursor-pointer"
                  :title="$t('generateDocument')"
                >
                  <feather-icon size="18" icon="FileTextIcon" />
                </div>

                <!-- View Invoice -->
                <div
                  class="cursor-pointer"
                  :title="$t('show')"
                  @click="$router.push(`/invoices/${row.id}/show`)"
                >
                  <feather-icon size="18" icon="EyeIcon" />
                </div>

                <!-- Edit Invoice -->
                <div
                  v-if="$can(`${$route.meta.permission}.edit`)"
                  class="cursor-pointer"
                  :title="$t('edit')"
                  @click="$router.push(`/invoices/${row.id}/edit`)"
                >
                  <feather-icon size="18" icon="Edit2Icon" />
                </div>

                <!-- Delete Draft Invoice -->
                <div
                  v-if="
                    row.status == 'draft' &&
                    $can(`${$route.meta.permission}.delete`)
                  "
                  class="cursor-pointer"
                  :title="$t('trash')"
                  @click="destroy(row.id)"
                >
                  <feather-icon size="18" icon="TrashIcon" />
                </div>
              </div>
            </div>

            <div class="card-body pt-0">
              <ul class="card-list">
                <!-- <li>
                  <div class="left">
                    <strong>{{ $t("invoiceNumber") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.invoiceNumber }}</span>
                  </div>
                </li> -->
                <li>
                  <div class="left">
                    <strong>{{ $t("receiver") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.companyName }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("invoiceType") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.invoiceType }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("dueDate") }}: </strong>
                  </div>
                  <div class="right">
                    <span>
                      {{ $dateFormatter(row.dueDate, $i18n.locale) }}</span
                    >
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("status") }}: </strong>
                  </div>
                  <div class="right">
                    <select
                      class="form-control w-100"
                      @change="updateInvoice(row, $event.target.value)"
                    >
                      <option
                        v-for="status in filterStatusOptions(row.status)"
                        :key="status"
                        :value="status"
                      >
                        {{ status }}
                      </option>
                    </select>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("netto") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{
                      $formatter(row.netto, $i18n.locale, "EUR", false, 2, 2)
                    }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("taxAmount") }}: </strong>
                  </div>
                  <div class="right">
                    {{
                      $formatter(
                        row.taxAmount,
                        $i18n.locale,
                        "EUR",
                        false,
                        2,
                        2
                      )
                    }}
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("totalAmount") }}: </strong>
                  </div>
                  <div class="right">
                    {{
                      $formatter(
                        row.totalAmount,
                        $i18n.locale,
                        "EUR",
                        false,
                        2,
                        2
                      )
                    }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <div class="d-flex justify-content-center mt-2">
            <b-pagination
              :value="1"
              :total-rows="totalRecords"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => onPageChange({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
    <!--==================================-->
    <!--==================================-->
    <div class="c-modal" v-show="showModal">
      <div class="c-modal-content">
        <div class="c-modal-header">
          <h3>{{ $t("sendMail") }}</h3>
          <div class="x-icon">
            <feather-icon size="16" icon="XIcon" @click="closeModal" />
          </div>
        </div>
        <div class="c-modal-body">
          <SendMailModal
            :to="invoiceEmailAddress"
            :invoiceTemplate="invoiceTemplate"
            :jsonData="selectedMailInvoice"
            v-if="showModal"
          />
        </div>
      </div>
    </div>
    <b-modal
      id="edit-tag-modal"
      v-model="showPromptModal"
      :title="$t('doYouReallyWantToResendTheInvoice')"
      centered
      size="md"
      hide-footer
    >
      <div class="d-flex align-items-center justify-content-end mt-2">
        <b-button
          class="mr-2"
          @click="showPromptModal = false"
          variant="primary"
          >{{ $t("cancel") }}</b-button
        >
        <b-button @click="toggleModal(selectedInvoice)" variant="primary">{{
          $t("resendMail")
        }}</b-button>
      </div>
    </b-modal>

    <b-modal
      id="invoice-summary-modal"
      v-model="showInvoiceSummaryModal"
      :title="$t('invoiceSummary')"
      centered
      size="md"
      hide-footer
    >
      <div class="form-group">
        <label class="form-label">{{ $t("month") }}</label>
        <select v-model="invoiceSummaryForm.month" class="form-control">
          <option value="01">{{ $t("january") }}</option>
          <option value="02">{{ $t("february") }}</option>
          <option value="03">{{ $t("march") }}</option>
          <option value="04">{{ $t("april") }}</option>
          <option value="05">{{ $t("may") }}</option>
          <option value="06">{{ $t("june") }}</option>
          <option value="07">{{ $t("july") }}</option>
          <option value="08">{{ $t("august") }}</option>
          <option value="09">{{ $t("september") }}</option>
          <option value="10">{{ $t("october") }}</option>
          <option value="11">{{ $t("november") }}</option>
          <option value="12">{{ $t("december") }}</option>
        </select>
      </div>
      <div class="form-group">
        <label class="form-label">{{ $t("year") }}</label>
        <select v-model="invoiceSummaryForm.year" class="form-control">
          <option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          @click="closeInvoiceSummaryModal()"
          variant="secondary"
          class="mr-2"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          @click="generateInvoiceSummary()"
          variant="primary"
          :disabled="!invoiceSummaryForm.month || !invoiceSummaryForm.year"
        >
          {{ $t("generateSummary") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { mapGetters } from "vuex";
import SendMailModal from "../components/SendMailModal.vue";
import NotificationService from "../../services/notification.service";
import Multiselect from "vue-multiselect";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import SearchFilter from "@/components/SearchFilter.vue";
import { props } from "vue-prism-component";
import { debounce } from "@/utils/debounce";
import MonacoEditor from "monaco-editor-vue";
import JSZip from "jszip";
import * as XLSX from "xlsx";
export default {
  components: {
    PageHeader,
    Multiselect,
    SearchFilter,
    MultiSelectInput,
    MonacoEditor,
    SendMailModal,
  },
  computed: {
    ...mapGetters("customers", ["customers"]),
    optionalItems() {
      return {
        createBtn1: {
          show: true,
          text: this.$t("createInvoice"),
          icon: "PlusIcon",
          path: "/invoices/create",
          permission: `${this.$route.meta.permission}.create`,
        },
      };
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("invoices"),
          active: true,
        },
      ];
    },
    columns() {
      return [
        {
          label: this.$t(""),
          field: "checkbox",
          sortable: false,
        },
        {
          label: this.$t("invoiceNumber"),
          field: "invoiceNumber",
        },
        {
          label: this.$t("receiver"),
          field: "Company.companyName",
        },
        {
          label: this.$t("invoiceType"),
          field: "invoiceType",
        },
        {
          label: this.$t("dueDate"),
          field: "dueDate",
        },
        {
          label: this.$t("status"),
          field: "status",
        },
        {
          label: this.$t("netto"),
          field: "netto_numeric",
        },
        {
          label: this.$t("taxAmount"),
          field: "taxAmount_numeric",
        },
        {
          label: this.$t("totalAmount"),
          field: "totalAmount_numeric",
        },
        {
          tdClass: "vgt-center-align",
          thClass: "vgt-center-align",
          label: this.$t("action"),
          field: "action",
          sortable: false,
        },
      ];
    },
    yearOptions() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = 2020; year <= currentYear; year++) {
        years.push(year);
      }
      return years.reverse();
    },
  },
  watch: {
    selectedRows(newVal) {
      this.selectAll = newVal.length === this.rows.length;
    },
    form: {
      handler() {
        this.debouncedFetch();
      },
      deep: true,
    },
  },
  data() {
    return {
      options: {
        //Monaco Editor Options
      },
      selectedMailInvoice: {},
      showModal: false,
      totalRecords: 0,
      pageLength: 25,
      selectAll: false,
      selectedRows: [],
      page: 1,
      rows: [],
      sortBy: "createdAt",
      sortOrder: "desc",
      form: {
        invoiceType: "",
        status: "",
        company: "",
        type: "",
        search: "",
        status: "",
      },

      modelData: {},
      mailData: {},
      selectedInvoice: {},
      reminderLevels: [],
      invoiceTemplate: {},
      invoiceEmailAddress: "",
      showPromptModal: false,
      showInvoiceSummaryModal: false,
      invoiceSummaryForm: {
        month: new Date().getMonth() < 10 ? `0${new Date().getMonth()}` : `${new Date().getMonth()}`,
        year: new Date().getFullYear().toString(),
      },
    };
  },

  async created() {
    this.$store.commit("showLoader", true);
    try {
      this.debouncedFetch = debounce(async (newValue, oldValue) => {
        try {
          await this.loadItems();
        } catch (e) {
          console.error(e);
        }
      }, 300);
      this.loadItems();
      const response2 = await this.$store.dispatch(
        "mailTemplates/mailTemplateAssignmentList"
      );
      this.mailData = response2?.data?.data ?? {};
      const response = await this.$store.dispatch(
        "invoices/documentAssignmentList"
      );
      this.modelData = response?.data?.data ?? {};
      let reminders = await this.$store.dispatch("invoiceReminderLevel/list");
      this.reminderLevels = reminders?.data?.data;
      await this.$store.dispatch("customers/list", { isMultiSelect: true });
    } catch (error) {
      console.error("Error loading initial data:", error);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this, newProps);
    },
    filterStatusOptions(status) {
      const allOptions = [
        "draft",
        "approved",
        "sent",
        "warning level 1",
        "warning level 2",
        "warning level 3",
        "paid",
      ];

      const statusIndex = allOptions.indexOf(status);

      if (statusIndex !== -1) {
        // Update statusOptions to remove all previous statuses
        return allOptions.slice(statusIndex);
      } else {
        // If the status is not found, keep all options
        return allOptions;
      }
    },
    onPageChange(params) {
      this.page = params.currentPage;
      this.loadItems();
    },
    toggleModal(invoice) {
      this.showPromptModal = false;

      if (invoice.invoiceType == "invoice") {
        this.invoiceTemplate = this.mailData.find(
          (item) => item.module === "invoiceTemplate"
        );
      }

      if (invoice.invoiceType == "invoice-correction") {
        this.invoiceTemplate = this.mailData.find(
          (item) => item.module === "invoiceCorrectionTemplate"
        );
      }

      if (invoice.invoiceType == "invoice-storno") {
        this.invoiceTemplate = this.mailData.find(
          (item) => item.module === "invoiceStornoTemplate"
        );
      }

      this.invoiceEmailAddress = invoice.company?.invoiceEmailAddress ?? "";
      this.selectedMailInvoice = JSON.stringify(invoice);
      this.showModal = true;
    },
    showSentModal(invoice) {
      this.selectedInvoice = invoice;

      this.showPromptModal = true;
    },
    async downloadCSV() {
      try {
        await this.$store.dispatch("invoices/download");
      } catch (e) {}
    },
    async downloadLatestCSV() {
      try {
        await this.$store.dispatch("invoices/downloadLatestCSV");
      } catch (e) {}
    },
    async downloadInvoicePlan() {
      try {
        await this.$store.dispatch("invoices/downloadInvoicePlan");
      } catch (e) {}
    },
    async updateInvoice(invoice, status) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToChangeTheStatusTo") + status + "?",
        subText: this.$t("yesChangeIt"),
      });

      if (confirmed) {
        let payload = {};
        let storeDispatch = "invoices/update";
        if (invoice.status !== "draft") {
          payload = { status: status };
          storeDispatch = "invoices/updateStatus";
        } else {
          payload = {
            ...invoice,
            senderId: invoice.sender?.id ?? null,
            status: status,
          };
        }
        await this.$store
          .dispatch(storeDispatch, {
            id: invoice.id,
            data: payload,
          })
          .finally(() => {
            this.loadItems();
          });
      } else {
        this.loadItems();
      }
    },

    onPerPageChange(params) {
      this.updateParams({ pageLength: params.pageLength });
      this.loadItems();
    },
    closeModal() {
      this.showModal = false;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Map over rows to extract all IDs
        this.selectedRows = this.rows.map((row) => row.id);
      } else {
        this.selectedRows = [];
      }
    },
    async generate(invoice) {
      let templateId;
      if (invoice.status.startsWith("warning level")) {
        const matchedLevel = this.reminderLevels.find(
          (level) => level.levelName === invoice.status
        );

        templateId = matchedLevel ? matchedLevel.documentTemplateId : "";
      } else {
        // Handle other cases based on the form status
        switch (invoice.status) {
          case "invoice":
            templateId = this.modelData?.invoiceTemplateId ?? "";
            break;
          case "invoice-correction":
            templateId = this.modelData?.invoiceCorrectionTemplateId ?? "";
            break;
          case "invoice-storno":
            templateId = this.modelData?.invoiceStornoTemplateId ?? "";
            break;
          default:
            templateId = this.modelData?.invoiceTemplateId ?? ""; // Fallback to invoiceTemplateId
        }
      }
      if (templateId != "") {
        // Safeguard to ensure convertDate returns a valid Date object
        const parseDate = (date) => {
          const parsedDate = this.convertDate(date);
          return parsedDate instanceof Date && !isNaN(parsedDate)
            ? parsedDate
            : new Date(date);
        };

        const invoiceDate = invoice?.invoiceDate
          ? parseDate(invoice.invoiceDate)
          : this.formatDateLite(new Date());

        const startDate = invoice?.startDate
          ? parseDate(invoice.startDate)
          : null;

        const endDate = invoice?.endDate ? parseDate(invoice.endDate) : null;

        const dueDate = invoice?.dueDate ? parseDate(invoice.dueDate) : null;

        const draftStatusChangeDate = invoice?.invoiceDate
          ? parseDate(invoice.invoiceDate)
          : null;

        // Create the payload
        const payload = {
          ...invoice,
          customers: invoice.company,
          invoiceStatus: invoice.status,
          totalAmount: invoice.totalAmount,
          totalTaxAmount: invoice.taxAmount,
          totalAmountWithoutTax: invoice.netto,
          invoiceDate: invoiceDate.toLocaleDateString(),
          startDate: startDate ? startDate.toLocaleDateString() : null,
          endDate: endDate ? endDate.toLocaleDateString() : null,
          dueDate: dueDate ? dueDate.toLocaleDateString() : null,
          draftStatusChangeDate: draftStatusChangeDate
            ? draftStatusChangeDate.toLocaleDateString()
            : "",
          id: templateId,
          output: "pdf",
          updatedTime: Date.now(),
        };

        // Generate the filename
        const filename =
          "invoice-" +
          (invoice.invoiceNumber == null ? "draft" : invoice.invoiceNumber) +
          `.${"pdf"}`;

        // Dispatch the action
        this.$store.commit("showLoader", true);
        const response = await this.$store
          .dispatch("documentService/processTemplate", {
            data: payload,
            filename: filename,
            documentType: "pdf",
          })
          .finally(() => {
            this.$store.commit("showLoader", false);
          });

      } else {
        NotificationService.showError("Please assign document template first");
      }
    },
    async generateSelected() {
      // Filter rows where invoice.id exists in selectedRows array
      const selectedInvoices = this.rows.filter((invoice) =>
        this.selectedRows.includes(invoice.id)
      );
      for (let i = 0; i < selectedInvoices.length; i++) {
        try {
          await this.generate(selectedInvoices[i]); // Try generating
        } catch (error) {
          console.error(
            `Error processing invoice ${selectedInvoices[i].id}:`,
            error
          );
        }
      }
    },

    convertDate(dateString) {
      // Convert the date string into a Date object
      const date = new Date(dateString);

      // Convert the date to the desired format (Pakistan Standard Time)
      // Forcing timezone shift by setting the time to GMT+0500
      date.setTime(date.getTime() + 5 * 60 * 60 * 1000); // Add 5 hours

      // Return the formatted string
      return date.toString();
    },
    formatDateLite(date, showTime = false) {
      try {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${date.getFullYear()}-${m < 10 ? "0" : ""}${m}-${
          d < 10 ? "0" : ""
        }${d}${showTime ? " " + date.toLocaleTimeString() : ""}`;
      } catch (e) {
        return date;
      }
    },
    onSortChange(params) {
      this.sortOrder = params[0].type;
      if (params[0].type == "none") this.sortOrder = "asc";

      this.sortBy = params[0].field;
      this.loadItems();
    },

    // load items is what brings back the rows from server
    async loadItems() {
      try {
        this.$store.commit("showLoader", true);
        let response = await this.$store.dispatch("invoices/list", {
          page: this.page,
          ...this.form,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          search: this.form.search,
          company: this.form.company?.id ?? "",
          perPage: this.pageLength,
        });
        this.rows = response?.data?.data;
        this.totalRecords = response?.data?.total;
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async destroy(id) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        await this.$store.dispatch("invoices/destroy", id).finally(() => {
          this.loadItems();
        });
      }
    },
    reset() {
      this.form = {
        invoiceType: "",
        status: "",
        search: "",
        company: "",
      };
    },
    openInvoiceSummaryModal() {
      this.showInvoiceSummaryModal = true;
    },
    closeInvoiceSummaryModal() {
      this.showInvoiceSummaryModal = false;
    },
    async generateInvoiceSummary() {
      if (this.invoiceSummaryForm.month && this.invoiceSummaryForm.year) {
        this.$store.commit("showLoader", true);
        
        try {
          const response = await this.$store.dispatch("invoices/generateInvoiceSummary", {
            month: this.invoiceSummaryForm.month,
            year: this.invoiceSummaryForm.year,
          });
          this.closeInvoiceSummaryModal();
          
          if (response?.data?.data?.length > 0) {
            let templateId;
            if (this.modelData.invoiceSummaryTemplateId) {
              templateId = this.modelData.invoiceSummaryTemplateId;
            }
            
            if (templateId) {
              const zip = new JSZip();
              
              const payload = {
                ...response?.data?.data,
                id: templateId,
                output: "pdf",
                updatedTime: Date.now()
              };
              
              const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
              ];
              const monthName = monthNames[this.invoiceSummaryForm.month - 1];
              
              const processTemplateBase64Response = await this.$store.dispatch("documentService/processTemplateBase64", {
                data: payload,
                filename: `DTInvoiceSummary-${monthName}.pdf`,
                documentType: "pdf",
              });
              
              if (processTemplateBase64Response instanceof Blob) {
                const summaryBase64 = await this.convertBlobToBase64(processTemplateBase64Response);
                const summaryPdfData = this.base64ToArrayBuffer(summaryBase64);
                zip.file(`DTInvoiceSummay${monthName}.pdf`, summaryPdfData);

                const invoices = response?.data?.data || [];
                
                const excelData = this.generateExcelData(invoices);
                const excelBuffer = this.generateExcelFile(excelData);
                zip.file(`DTInvoiceSummary${monthName}.xlsx`, excelBuffer);
                const caseNameCount = {};
                
                for (let i = 0; i < invoices.length; i++) {
                  const invoice = invoices[i];
                  const invoiceNumber = String(i + 1).padStart(2, '0');
                  try {
                    const individualInvoiceBlob = await this.generateIndividualInvoice(invoice);
                    if (individualInvoiceBlob) {
                      const invoiceBase64 = await this.convertBlobToBase64(individualInvoiceBlob);
                      const invoicePdfData = this.base64ToArrayBuffer(invoiceBase64);
                      
                      let invoiceFilename;
                      if (invoice.caseName && invoice.caseName.trim() !== '') {
                        const cleanCaseName = invoice.caseName.trim();
                        if (caseNameCount[cleanCaseName]) {
                          caseNameCount[cleanCaseName]++;
                          invoiceFilename = `DTInvoice${cleanCaseName}_${caseNameCount[cleanCaseName]}.pdf`;
                        } else {
                          caseNameCount[cleanCaseName] = 1;
                          invoiceFilename = `DTInvoice${cleanCaseName}.pdf`;
                        }
                      } else {
                        invoiceFilename = `DTInvoice${invoiceNumber}.pdf`;
                      }
                      
                      zip.file(invoiceFilename, invoicePdfData);
                    }
                  } catch (error) {
                    console.error(`Error generating invoice ${invoiceNumber}:`, error);
                  }
                }

                const zipBlob = await zip.generateAsync({ type: "blob" });
                const zipObjectUrl = URL.createObjectURL(zipBlob);
                const zipLink = document.createElement("a");
                zipLink.href = zipObjectUrl;
                zipLink.download = `invoices-${monthName}-${this.invoiceSummaryForm.year}.zip`;
                zipLink.style.display = "none";
                document.body.appendChild(zipLink);
                zipLink.click();
                document.body.removeChild(zipLink);
                URL.revokeObjectURL(zipObjectUrl);

                const zipBase64 = await this.convertBlobToBase64(zipBlob);
                
                await this.$store.dispatch("invoices/sendMail", {
                  base64: zipBase64,
                  fileName: `invoices-${monthName}-${this.invoiceSummaryForm.year}.zip`
                });
              }
            } else {
              NotificationService.showError("Please assign invoice summary template first");
            }
          } else {
            NotificationService.showInfo("No invoices found for the selected period");
          }
        } catch (error) {
          console.error("Error generating invoice summary:", error);
        } finally {
          this.$store.commit("showLoader", false);
        }
      }
    },
    convertBlobToBase64(data) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onerror = (err) => {
          reject(err);
        };
        reader.onloadend = () => {
          resolve(reader.result);
        };

      });
    },
    base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64.split(',')[1]);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes;
    },
    async generateIndividualInvoice(invoice) {
      let templateId;
      if (invoice.status.startsWith("warning level")) {
        const matchedLevel = this.reminderLevels.find(
          (level) => level.levelName === invoice.status
        );
        templateId = matchedLevel ? matchedLevel.documentTemplateId : "";
      } else {
        switch (invoice.status) {
          case "invoice":
            templateId = this.modelData?.invoiceTemplateId ?? "";
            break;
          case "invoice-correction":
            templateId = this.modelData?.invoiceCorrectionTemplateId ?? "";
            break;
          case "invoice-storno":
            templateId = this.modelData?.invoiceStornoTemplateId ?? "";
            break;
          default:
            templateId = this.modelData?.invoiceTemplateId ?? "";
        }
      }
     
      if (templateId) {
        const parseDate = (date) => {
          const parsedDate = this.convertDate(date);
          return parsedDate instanceof Date && !isNaN(parsedDate)
            ? parsedDate
            : new Date(date);
        };

        const invoiceDate = invoice?.invoiceDate
          ? parseDate(invoice.invoiceDate)
          : this.formatDateLite(new Date());

        const startDate = invoice?.startDate
          ? parseDate(invoice.startDate)
          : null;

        const endDate = invoice?.endDate ? parseDate(invoice.endDate) : null;
        const dueDate = invoice?.dueDate ? parseDate(invoice.dueDate) : null;
        const draftStatusChangeDate = invoice?.invoiceDate
          ? parseDate(invoice.invoiceDate)
          : null;

        const payload = {
          ...invoice,
          customers: invoice.company,
          invoiceStatus: invoice.status,
          totalAmount: invoice.totalAmount,
          totalTaxAmount: invoice.taxAmount,
          totalAmountWithoutTax: invoice.netto,
          invoiceDate: invoiceDate.toLocaleDateString(),
          startDate: startDate ? startDate.toLocaleDateString() : null,
          endDate: endDate ? endDate.toLocaleDateString() : null,
          dueDate: dueDate ? dueDate.toLocaleDateString() : null,
          draftStatusChangeDate: draftStatusChangeDate
            ? draftStatusChangeDate.toLocaleDateString()
            : "",
          id: templateId,
          output: "pdf",
          updatedTime: Date.now(),
        };

        const filename = `invoice-${invoice.invoiceNumber == null ? "draft" : invoice.invoiceNumber}.pdf`;

        try {
          const response = await this.$store.dispatch("documentService/processTemplateBase64", {
            data: payload,
            filename: filename,
            documentType: "pdf",
          });
          return response;
        } catch (error) {
          console.error(`Error generating individual invoice ${invoice.invoiceNumber || 'draft'}:`, error);
          return null;
        }
      }
      return null;
    },
    generateExcelData(invoices) {
      const headers = [
        'Date',
        'Produkt',
        'Case Name',
        'Amount',
        'Credits',
        'Credits Total',
        'Avg Credit Price',
        'Tax',
        'Price'
      ];
      
      const data = [headers];
      
      invoices.forEach(invoice => {
        const parseDate = (date) => {
          const parsedDate = this.convertDate(date);
          return parsedDate instanceof Date && !isNaN(parsedDate)
            ? parsedDate
            : new Date(date);
        };
        
        const invoiceDate = invoice?.invoiceDate
          ? parseDate(invoice.invoiceDate)
          : new Date();
        
        const formattedDate = invoiceDate.toLocaleDateString('de-DE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        
        const product = invoice.products && invoice.products.length > 0 ? invoice.products[0] : {};
        
        const row = [
          formattedDate,
          product.productName || product.name || 'N/A',
          invoice.caseName || 'N/A',
          product.quantity || 1,
          product.credits || 0,
          product.totalCredits || 0,
          product.creditPrice || 0,
          invoice.taxAmount || 0,
          invoice.totalAmount || 0
        ];
        
        data.push(row);
      });
      
      return data;
    },
    generateExcelFile(data) {
      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Invoice Summary');
      
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      return new Uint8Array(wbout);
    },
    formatSelectedPeriod() {
      if (this.invoiceSummaryForm.month && this.invoiceSummaryForm.year) {
        const monthNames = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const month = monthNames[new Date(this.invoiceSummaryForm.month).getMonth()];
        const year = this.invoiceSummaryForm.year;
        return `${month} ${year}`;
      }
      return '';
    },
  },
};
</script>

<style>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

</style>

